import { Component } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from 'src/app/services/log/log.service'

/**
 * deprecated
 */

@Component({ template: '' })
export class Header {
  constructor(protected generalService: GeneralService, protected logService: LogService) {}

  get isApp(): boolean {
    return this.generalService.isApp
  }

  toggleDrawer(): void {
    this.logService.eventLogging(LogEvent.HEADER_DRAWER_CLICKED, { from: location.pathname })
    this.generalService.openDrawer()
  }
}
